module.exports = __webpack_public_path__ + "static/media/danger.f0b39872.svg";